import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import CarSelectionBar from "../../components/carSelector/CarSelectionBar";
import type {ApplicationState} from "../../reducers";
import {createRef} from "react";
import {findDeepestVehiclePath, isVehicleKeyAncestor} from "../../helper/vehicleKey";

function mapStateToProps(state: ApplicationState, ownProps) {
	const brand = state.content.brand;
	const filterStatsSeries = state.filter.filterStats.vehicleSeries || [];
	const brandSeries = (brand && brand.vehicleSeries) || [];
	// The swimlane must render from the configure-time catalog snapshot (brand):
	// filterStats is rebuilt from the product aggregations of every products/overview
	// response, whose series frequently carry no imageUrl — binding the bar to it
	// makes vehicles vanish moments after the initial load.
	const filterVehicleSeries = brandSeries.filter(vehicleSeries => !!vehicleSeries.imageUrl);
	const filterObject = state.filter.filter;
	const directKeys = [filterObject.vehicle, filterObject.vehicleModel].filter(Boolean);
	const matchesSelection = vehicle => !!vehicle && (
		directKeys.some(key => vehicle.key === key || vehicle.name === key || vehicle.title === key)
		|| isVehicleKeyAncestor(filterObject.vehicleKey, vehicle.key)
	);

	// Resolve the deepest matching vehicle path. Try the products-filtered list
	// first (covers the common case where the selected vehicle has products);
	// fall back to the full brand catalog so we can still render a breadcrumb
	// for vehicles whose entire branch was filtered out (no products, or no image).
	let breadcrumbPath = findDeepestVehiclePath(filterStatsSeries, matchesSelection);
	if (breadcrumbPath.length === 0 || (filterObject.vehicleKey && breadcrumbPath[breadcrumbPath.length - 1].key !== filterObject.vehicleKey)) {
		const brandPath = findDeepestVehiclePath(brandSeries, matchesSelection);
		if (brandPath.length > breadcrumbPath.length) {
			breadcrumbPath = brandPath;
		}
	}

	const selectedVehicle = breadcrumbPath.length > 0 ? breadcrumbPath[breadcrumbPath.length - 1] : undefined;
	const selectionBreadcrumb = breadcrumbPath
		.map(node => (node && (node.title || node.name)) || "")
		.filter(Boolean)
		.join(" ➜ ");

	const filteredVehicleSeries = filterVehicleSeries.map(vehicle => {
		return {
			...vehicle,
			categories: vehicle.categories || [],
			carRef: createRef(),
		};
	});

	return {
		filteredVehicleSeries,
		brand,
		selectedVehicle,
		selectionBreadcrumb,
		vehicleKey: filterObject.vehicleKey,
	};
}

// Mirrors the render guard in CarSelectionBar: the bar only renders with an
// active vehicle filter or at least one selectable series with categories.
export function isCarSelectionBarVisible(state: ApplicationState): boolean {
	const {selectedVehicle, vehicleKey, filteredVehicleSeries} = mapStateToProps(state, {});
	return !!selectedVehicle || !!vehicleKey
		|| filteredVehicleSeries.some(vehicle => vehicle.categories.length > 0);
}

function mapDispatchToProps(dispatch, ownProps) {
	return {};
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CarSelectionBar));
